//Import dbtables.ts from warmerise-discord-bot
import { Warmerise_Custom_Assets } from './dbtables'

export async function getModeList(mymodesonly:boolean=true, page:number=0, search?:string, ): Promise<Warmerise_Custom_Assets[]> {
    try {
        const response = await fetch("https://bot.warmerise.com/api/listgameconfigs", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                mymodesonly: mymodesonly,
                page: page,
                search: search || ""
            })
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();

        if (!Array.isArray(data)) {
            throw new Error("Expected an array of objects");
        }

        return data as Warmerise_Custom_Assets[];
    } catch (error) {
        console.error("Error loading assets:", error);
        throw error;
    }
}

export async function getGameModeJson(modeassetid:number):Promise<any> {   
    return {
        //FIXME: add mock gamemode json(s) for selected mode(s)
    }
}